import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiService, AuthService, NotificationService, TohumUiModule, User } from '@anadolu-commons/tohum-ui';
import { Moduller, OgrenciSecimModel } from './ogrenci-secim.model';
import { map } from 'rxjs/operators';
import { TranslocoService } from "@ngneat/transloco";
import { SharedService } from '../shared.service';
import { FuncsService } from 'src/app/services/funcs.service';
import { InputTextComponent } from "../input-text/input-text.component";
import { CheckboxComponent } from "../checkbox/checkbox.component";

@Component({
  templateUrl: './ogrenci-secim.component.html',
  selector:'aof-ogrenci-secim',
  standalone: true,
  imports: [TohumUiModule, InputTextComponent, CheckboxComponent],
  styles: []
})
export class OgrenciSecimComponent implements OnInit {
  
  user: User;
  ogrenciAdinaBasvuruYapabilirMi = false;

  buttonPassive = false;
  sorgulamaYapildiMi = false;
  sorgulamaBasariliMi = false;
  profilEklenebilirMi = false;
  
  kendiTcNoKullanmakIstiyor = false;  
  yerineGirisMi: boolean = false;
  islemYapilacakAday: string = '';
  girisYapanId:string = '';
  tcNo: string = '';
  ad: string = '';
  soyad: string = '';
  
  @Input() islemYapilacakModul: Moduller; // todo: en son kaldırılacak
  @Output() close = new EventEmitter();

  constructor(private readonly apiService: ApiService, private authService: AuthService, 
    private funcs:FuncsService, private sharedService: SharedService,
    private translocoService: TranslocoService) { }

  ngOnInit() {
    this.user = this.authService.getUser();
    this.ogrenciAdinaBasvuruYapabilirMi = this.authService.hasPermissions(["Admin"]);

    // Sadece 'yerine giriş' yapılmışsa (yerineGirisMi$ true ise) panelde bu bilgiyi göster.
    // İlk girişteki otomatik profil sorgulaması (yerineGirisMi false) modalı doldurmasın.
    if (this.sharedService.yerineGirisMi$ === true) {
      this.tcNo = this.sharedService.tcNo$;
      this.yerineGirisMi = true;
      this.kendiTcNoKullanmakIstiyor = false;
      this.sorgulamaYapildiMi = true;
      this.sorgulamaBasariliMi = true;

      this.sharedService.profilAdSoyad$.subscribe(data => {
        if (data) {
          this.islemYapilacakAday = data.ad + " " + data.soyad;
        }
      });
    } else {
      this.kendiTcNoKullanmakIstiyor = false;
      this.islemYapilacakAday = '';
      this.sorgulamaYapildiMi = false;
    }

  }

  onTcNoKullanmakIstiyorChange(check: boolean) {
    this.kendiTcNoKullanmakIstiyor = check;
    this.tcNo = '';
    // this.sorgula();
  }
  sorgula() {

    this.buttonPassive = true;
    this.sorgulamaYapildiMi = false;
    if (!this.kendiTcNoKullanmakIstiyor && !this.sorgulaKontrol()) {
      this.buttonPassive = false;
      return;
    }

    this.girisYapanId = this.user.id;
    this.yerineGirisMi = this.ogrenciAdinaBasvuruYapabilirMi && !this.kendiTcNoKullanmakIstiyor;

    this.apiService.get('ogrenci-secimi/aday-profil-sorgula/', 
    {
      tcNo: this.tcNo,
      girisYapanId:  this.user.id,
      adminMi: this.ogrenciAdinaBasvuruYapabilirMi,
      kendiTcNoKullanmakIstiyor: this.kendiTcNoKullanmakIstiyor,      
    })
    .pipe(
      map(json => json.data)
    )
    .subscribe(result => {
      if (result.devamEdebilirMi) {
        this.islemYapilacakAday = result.ad + " " + result.soyad;
        this.sharedService.setProfilBilgi(result, this.yerineGirisMi);
        this.sharedService.setAdSoyadBilgi(result);
        this.sharedService.setBasvuruAsamasindaMi(false);
        this.sharedService.setOnBasvuruAsamasindaMi(false);

        this.sorgulamaYapildiMi = true;
        this.sorgulamaBasariliMi = true;
        this.profilEklenebilirMi = false;
        this.buttonPassive = false;
      }
      else {
        this.funcs.hataMesajiVerUi(result.mesaj);
        this.sorgulamaYapildiMi = true;
        this.sorgulamaBasariliMi = false;
        this.profilEklenebilirMi = false;
        this.buttonPassive = false;
      }
    },
    error => {
      this.sorgulamaYapildiMi = true;
      this.sorgulamaBasariliMi = false;
      this.profilEklenebilirMi = true;
      this.buttonPassive = false;
    });

  }

  sorgulaKontrol() {
    if (this.tcNo === undefined || this.tcNo === '') {
      this.funcs.bilgilendirmeMesajiVer_baslikIle(this.translocoService.translate('ogrenciSecimi.notificationTitle'),this.translocoService.translate('ogrenciSecimi.tcKimlikNoGirilmemis'));
      return false;
    }
    if (this.tcNo.trim().length !== 11) {
      this.funcs.bilgilendirmeMesajiVer_baslikIle(this.translocoService.translate('ogrenciSecimi.notificationTitle'),this.translocoService.translate('ogrenciSecimi.tcKimlikNoGecersiz'));
      return false;
    }
    return true;
  }
  tamam(){
    //todo: kapatmadan önce yerine giriş logu alınacak
    this.close.emit();
  }
  islemBasarili(){
    this.sorgula();
  }
  islemBasarisiz(event: any){
    this.funcs.hataMesajiVer(event);
  }
}
